import { ActionReducerMap } from '@ngrx/store';

export const reducers: ActionReducerMap<any> = {
  // test: (state, action) => {
  //   console.log(state, action);
  //   return state;
  // }
};
